<template>
<div class="xin">
    <div class="switch">
        <el-tabs>
            <el-tab-pane>
                <!-- ELK详细路由日志 -->

                <span slot="label"> {{ $t("logs.Queue") }}</span>
                <!-- 查询框 -->
                <div class="main">
                    <el-form ref="form" :model="form" label-width="80px">
                        <!-- 清空全部队列 -->

                        <el-button type="primary" @click="open" :disabled="$root.jurisdiction.only_query==0">{{
                $t("logs.clearAll")
              }}</el-button>
                        <!-- 清空推迟队列 -->

                        <el-button type="primary" @click="tan2()" :disabled="$root.jurisdiction.only_query==0">{{
                $t("logs.clearDef")
              }}</el-button>
                        <!-- 重投所有队列 -->

                        <el-button type="primary" @click="tan3()" :disabled="$root.jurisdiction.only_query==0"> {{
                $t("logs.resAll")
              }}</el-button>
                        <!-- 查找队列 -->

                        <el-button type="primary" @click="tan4()">{{
                $t("logs.query")
              }}</el-button>

                        <el-select v-model="salt_minion_ip" @change="change1" size="smail" v-if="pan==1" class="main_select_margin">
                            <el-option v-for="item in minion_host" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                        <el-select v-model="mta" @change="change2" size="smail" style=" width: 100px;" v-if="pan1==1" class="main_select_margin">
                            <el-option v-for="item in q_mta" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>

                        <p class="main_list">
                            <!-- 队列总数-->

                            <span>{{ $t("logs.Queuetotal") }}:</span>
                            <span style="color:red">{{ totalnums }}</span>

                            <el-alert :title="$t('logs.Queuetotal1')" type="warning" show-icon :closable="false"></el-alert>

                        </p>
                    </el-form>
                </div>
                <!-- 弹出框2-->
                <div class="pop-up" v-show="tanchu" v-drag ="{ handle: '.pop_up_text_ipcor' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_ipcor"><span class="span_pad"></span> {{$t('logs.query')}}</div>
                        <p></p>

                    <div class="find" >

                        <div class="find1" v-if="this.queue_show_subject==1">
                            <!--邮件主题 -->

                            <div class="find-text" style="padding-right:12px">{{ $t("logs.sand4_1") }}: </div>
                            <div class="block block1">
                                <el-input v-model="subject" placeholder=""></el-input>
                            </div>
                        </div>
                        <div class="find1">
                            <!--发件人 -->

                            <div class="find-text" style="padding-right:12px">{{ $t("logs.sand4_2") }}:</div>
                            <div class="block block1">
                                <el-input v-model="envfrom" placeholder=""></el-input>
                            </div>

                        </div>
                        <div class="find1">
                            <!--收件人 -->

                            <div class="find-text" style="padding-right:12px">{{ $t("logs.sand4_3") }}:</div>
                            <div class="block block1">
                                <el-input v-model="envrcpt" placeholder=""></el-input>
                            </div>
                        </div>

                        <div class="find1" v-if="pan==1">
                            <!--集群节点 -->

                            <div class="find-text" style="padding-right:12px">{{ $t("anti_gs1.Policytype") }}: </div>
                            <div class="block block1">

                                <el-select v-model="salt_minion_ip" placeholder="请选择">
                                    <el-option v-for="item in minion_host" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="find1" v-if="pan1==1">
                            <!--MTA -->

                            <div class="find-text" style="padding-right:12px">{{ $t("anti_gs1.Policytype") }}: </div>
                            <div class="block block1">
                                <el-select v-model="mta">
                                    <el-option v-for="item in q_mta" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>

                    <el-row>
                        <el-button type="primary" @click="tanSend()" :disabled="$root.jurisdiction.only_query == 0">{{$t('confirm.search')}}</el-button>
                        <el-button type="danger" @click="tanOff()">{{$t('confirm.cancel')}}</el-button>
                    </el-row>
                </div>

                <div class="gray" v-show="tanchu"></div>
                <!--  表格 -->
                <div class="table">
                    <el-table ref="multipleTable" tooltip-effect="dark" 
                    v-loading=" loading" style="width: 100%" :data="fileList" :cell-class-name="tableCellClassName" @selection-change="handleSelectionChange" :row-class-name="tableRowClassName">
                        <el-table-column type="selection" width="44" v-model="multipleSelection"></el-table-column>
                        <el-table-column prop="QID" :label="$t('logs.Queueid')" width="100">
                            <template slot-scope="scope">
                                <el-popover trigger="hover"  placement="bottom"  width="200" class="queue_list">
                                
                                  <el-button slot="reference" type="text"
                          size="small" v-if="scope.row.ISSENDING==1" style="color:#f00">{{
                          scope.row.QID 
                        }}</el-button>
                                        <el-button slot="reference" type="text"
                          size="small" v-if="scope.row.ISSENDING==0">{{
                          scope.row.QID 
                        }}</el-button>
                                   <div>{{scope.row.REASON}} </div>
                                </el-popover>
                            </template>
                        </el-table-column>

                        <el-table-column prop="AC_DATE" :label="$t('logs.sender')">
                        </el-table-column>
                        <el-table-column prop="ENVRCPT" :label="$t('logs.recipient')" >
                        </el-table-column>
                        <el-table-column prop="SUBJECT" :label="$t('wasteInsulate1.subject')"  v-if="this.queue_show_subject==1">
                        </el-table-column>
                        <el-table-column prop="SIZE" :label="$t('wasteInsulate1.bigs')" width="100">
                        </el-table-column>
                        <el-table-column prop="DAYTIME" :label="$t('wasteInsulate1.startdate')" width="120">
                        </el-table-column>
                        <el-table-column prop="address" :label="$t('table.operate')" width="120">
                            <template slot-scope="scope">
                                <!-- 删除-->

                                <el-button @click="handleClick1(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.delete") }}</el-button>
                                <!-- 快发-->

                                <el-button @click="sendk(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.chongFa") }}</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <!--  底部 -->
                <div class="footer fenye main">
 <!--  分页 -->
            <!-- <div class="fenye"> -->
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="page"
                        :page-sizes="this.q_page_size"

                :page-size="size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalnums"
              ></el-pagination>
            <!-- </div> -->
                    <!--  重投所选列表 -->

                    <el-button type="primary" plain @click="tan5()" :disabled="$root.jurisdiction.only_query==0" style="margin-left:10px">{{
              $t("logs.ressequ")
            }}</el-button>
                    <!--  删除所选列表 -->

                    <el-button type="warning" plain @click="tan6()" class="del_list" :disabled="$root.jurisdiction.only_query==0">{{
              $t("logs.ressequ1")
            }}</el-button>
                </div>
            </el-tab-pane>
            <el-tab-pane label="">

            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            subject: '',
            envfrom: '',
            envrcpt: '',
            // 页面初始判断
            pan: '',
            pan1: '',
            queue_show_subject:'',
            multipleSelection: [],
            // 下拉框
            salt_minion_ip: '',
            mta: "",
 q_page_size:[],
          
        

            q_mta: '',
            minion_host: [],
          
            xian: false,
            btnText: "展示更多",
            checked: "",
            form: {
                username: "",
            },
             // 总数
      totalnums: 0,
      size: 0,
      // 每页条数
      pagesize: 0,
      //   默认前往第几页
      page: 1,
            value: "",
            value1: [new Date(2020, 5, 10, 10, 10), new Date(2020, 6, 11, 10, 10)],
            tanchu: false,
            poptime: [{
                    value: "选项1",
                    label: "所以节点",
                },
                {
                    value: "选项2",
                    label: "211.100.61.211",
                },
                {
                    value: "选项3",
                    label: "211.100.61.209",
                },
                {
                    value: "选项4",
                    label: "211.100.47.36",
                },
                {
                    value: "选项5",
                    label: "本机",
                },
            ],

            emali: "",
            col: {
                a: "",
            },
            fileList: [],
            loading:false,
        };
    },
    mounted() {
        this.getFileList();
    },
    methods: {
          // 每页显示多少条 -- 切换
    handleSizeChange(val) {
      // this.col = this.col_search;
      // this.col.pagesize = val;
      this.pagesize = val;

      // console.log(this.col, "给后台返回数据2");

      this.getFileList();
    },
    // 当前第几页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      // this.col = this.col_search;
      // this.col.page = val;
      this.page = val;

      this.getFileList();
    },
        // 各行变色
        tableRowClassName({
            rowIndex
        }) {
            // console.log(row,rowIndex)
            if (rowIndex % 2 == 1) {
                return "warning-row";
                // console.log(2222)
            } else if (rowIndex % 2 !== 1) {
                return "success-row";
            }
            return "";
        },
        // 表格选中值
        handleSelectionChange(val) {
            this.multipleSelection = val;
            // console.log(this.multipleSelection, "table 框选中的值");
            // console.log(this.table);
        },
        // 下拉框点击选中
        change1(a) {
            console.log(a);
            this.salt_minion_ip= a;
           this.getFileList()
               
        },
        change2(a) {
            console.log(a);
            this.mta= a;
           this.getFileList()
           
               
        },
        // 数据加载
        getFileList() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            let col1 = {

                salt_minion_ip:  this.salt_minion_ip,
                mta: this.mta,
            };
            let col = col1;
            // console.log(col, '5555')
            this.loading = true;

            this.$axios
                .get("/api/adm/cgi/mon.cgi", {
                    params: {
                        __mode: "show_cur_queue",
                        sid: sid,
                        col: col,
                         page: this.page,
            pagesize: this.pagesize,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res);
                        this.loading=false

                    // console.log(col, "传的col值");
                    this.col1 = this.col;
                    // console.log(this.col1, "传的col1值");
                    // console.log(this.page, '222')

                   if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                       
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        // alert("请重新登录");
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                         this.queue_show_subject=res.data.ret.SYS_QUEUE_SHOW_SUBJECT;
                        this.pan = res.data.ret.HAS_MINION
                        this.pan1 = res.data.ret.SYS_HAS_MULTI_MTA
                        if (res.data.ret.HAS_MINION == 1) {
                           
                            this.salt_minion_ip = res.data.ret.col.salt_minion_ip;
                            this.minion_host = res.data.ret.q_minion_host;
                        }
                        if (res.data.ret.SYS_HAS_MULTI_MTA == 1) {
                           
                            this.q_mta = res.data.ret.q_mta;
                            this.mta = res.data.ret.col.mta;
                        }
                        this.q_page_size = res.data.ret.q_pagesize;

                        this.fileList = res.data.ret.datalist;

                        this.totalnums = res.data.ret.col.totalnums;
                         this.size = res.data.ret.col.pagesize;
            this.page = res.data.ret.col.page;
            this.$refs.multipleTable.clearSelection()
                        // console.log(this.page)

                    }
                })
               
        },
        // 删除
        handleClick1(index, scope) {
            console.log(index, scope);
            this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let col1 = {
                        qid: scope.QID,
                        salt_minion_ip: this.salt_minion_ip,
                        mta: this.mta,
                    };
                    this.$axios
                        .get("/api/adm/cgi/mon.cgi", {
                            params: {
                                __mode: "delete_qid",
                                sid: sid,
                                col: col1,
                            },
                        })
                        .then((res) => {
                            console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                              
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList();
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("anti_gs1_tan.del1")}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("anti_gs1_tan.del2")}`,
                    });
                });
        },
        // 快发
        sendk(index, scope) {
            console.log(index, scope);
            this.$confirm(`${this.$t("logs.kuaifa")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                                this.loading = true;

                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let col1 = {
                        qid: scope.QID,
                        salt_minion_ip: this.salt_minion_ip,
                        mta: this.mta,
                    };
                    this.$axios
                        .get("/api/adm/cgi/mon.cgi", {
                            params: {
                                __mode: "resend_qid",
                                sid: sid,
                                col: col1,
                            },
                        })
                        .then((res) => {
                            console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                this.loading = false;

                               
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList();
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("logs.kuaifa1")}`,
                                });
                            }
                        });
                })
                .catch(() => {
                                this.loading = false;

                    this.$message({
                        type: "info",
                        message: `${this.$t("logs.kuaifa2")}`,
                    });
                });
        },
        // 判断状态变色
        tableCellClassName({
            row
        }) {
            // console.log(row);

            if (row.ISSENDING == 1) {
                return "sent1";
            } else if (row.ISSENDING == 0) {
                return "sent2";
            }
            return "";
        },
        // 清空全部队列
        open() {
            this.$confirm(
                    `${this.$t('logs.qing1')}`, {
                        confirmButtonText: `${this.$t('tan.confirm')}`,
                        cancelButtonText: `${this.$t('tan.cancel')}`,
                        type: "warning",
                    }
                )
                .then(() => {
                    this.loading=true;
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let col1 = {
                        salt_minion_ip: this.salt_minion_ip,
                        mta: this.mta,
                    };
                    this.$axios
                        .get("/api/adm/cgi/mon.cgi", {
                            params: {
                                __mode: "clear_qid",
                                sid: sid,
                                col: col1,
                            },
                        })
                        .then((res) => {
                            console.log(res);
 this.loading=false;
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                // this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList();
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("logs.kuaifa1")}`,
                                });
                            }
                        });

                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("logs.kuaifa2")}`,
                    });
                });
        },
        tan2() {
            this.$confirm(
                    `${this.$t('logs.qing2')}`, {
                        confirmButtonText: `${this.$t('tan.confirm')}`,
                        cancelButtonText: `${this.$t('tan.cancel')}`,
                        type: "warning",
                    }
                )
                .then(() => {
                    this.loading=true;
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let col1 = {
                        salt_minion_ip: this.salt_minion_ip,
                        mta: this.mta,
                    };
                    this.$axios
                        .get("/api/adm/cgi/mon.cgi", {
                            params: {
                                __mode: "clear_deferred_qid",
                                sid: sid,
                                col: col1,
                            },
                        })
                        .then((res) => {
                            console.log(res);
this.loading=false;
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                // this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList();
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("logs.kuaifa3")}`,
                                });
                            }
                        });

                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("logs.kuaifa2")}`,
                    });
                });
        },
        tan3() {
            this.$confirm(`${this.$t('logs.qing3')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    this.loading=true;
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let col1 = {
                        salt_minion_ip: this.salt_minion_ip,
                        mta: this.mta,
                    };
                    this.$axios
                        .get("/api/adm/cgi/mon.cgi", {
                            params: {
                                __mode: "resend_allqid",
                                sid: sid,
                                col: col1,
                            },
                        })
                        .then((res) => {
                            console.log(res);
this.loading=false;
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                // this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList();
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("logs.kuaifa1")}`,
                                });
                            }
                        });

                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("logs.kuaifa2")}`,
                    });
                });
        },
        tan5() {
            if (this.multipleSelection.length === 0) {
                this.$message({
                    message: `${this.$t("logs.qing6")}`,
                    type: "warning",
                });
                return;
            } else {

                this.$confirm(`${this.$t("logs.qing4")}`, {
                        confirmButtonText: `${this.$t('tan.confirm')}`,
                        cancelButtonText: `${this.$t('tan.cancel')}`,
                        type: "warning",
                    })
                    .then(() => {
                                    this.loading = true;

                        let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid
                        var arr = this.multipleSelection;
                        // console.log(arr, "全选后，获取的数组");
                        let multis = [];
                        for (var i = 0; i < arr.length; i++) {
                            multis.push(arr[i].QID);
                        }
                        console.log(multis, "选中后的批量放行id");
                        let multis1 = JSON.stringify(multis);
                        let col1 = {
                            salt_minion_ip: this.salt_minion_ip,
                            mta: this.mta,
                            qid_json: multis1
                        };
                        this.$axios
                            .get("/api/adm/cgi/mon.cgi", {
                                params: {
                                    __mode: "resend_select_queue",
                                    sid: sid,
                                    col: col1,
                                },
                            })
                            .then((res) => {
                                console.log(res);

                                if (!res.data.fmstatus) {
                                    alert(res.data);
                                } else if (res.data.fmstatus.code == "1") {
                                    alert(res.data.fmstatus.errmsg);
                                } else if (res.data.fmstatus.code == "2") {
                                    alert(res.data.fmstatus.errmsg);
                                    this.loading = false;

                                    // this.getFileList();
                                } else if (res.data.fmstatus.code == "3") {
                                    alert(res.data.fmstatus.errmsg);
                                    this.$router.push({
                                        name: "login",
                                    });
                                } else {
                                    this.loading = false;
                                    this.getFileList();
                                    this.$message({
                                        type: "success",
                                        message: `${this.$t("logs.kuaifa1")}`,
                                    });
                                }
                            });

                    })
                    .catch(() => {
                                    this.loading = false;

                        this.$message({
                            type: "info",
                            message: `${this.$t("logs.kuaifa2")}`,
                        });
                    });
            }
        },
        tan6() {
            if (this.multipleSelection.length === 0) {
                this.$message({
                    message: `${this.$t("logs.qing6")}`,
                    type: "warning",
                });
                return;
            } else {
                this.$confirm("确定删除所有选中的队列？", "提示", {
                        confirmButtonText: `${this.$t('tan.confirm')}`,
                        cancelButtonText: `${this.$t('tan.cancel')}`,
                        type: "warning",
                    })
                    .then(() => {
  this.loading = true;

                        let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid
                        var arr = this.multipleSelection;
                        // console.log(arr, "全选后，获取的数组");
                        let multis = [];
                        for (var i = 0; i < arr.length; i++) {
                            multis.push(arr[i].QID);
                        }
                        console.log(multis, "选中后的批量放行id");
                        let multis1 = JSON.stringify(multis);
                        let col1 = {
                            salt_minion_ip: this.salt_minion_ip,
                            mta: this.mta,
                            qid_json: multis1
                        };
                        this.$axios
                            .get("/api/adm/cgi/mon.cgi", {
                                params: {
                                    __mode: "delete_select_queue",
                                    sid: sid,
                                    col: col1,
                                },
                            })
                            .then((res) => {
                                console.log(res);

                                if (!res.data.fmstatus) {
                                    alert(res.data);
                                } else if (res.data.fmstatus.code == "1") {
                                    alert(res.data.fmstatus.errmsg);
                                } else if (res.data.fmstatus.code == "2") {
                                    alert(res.data.fmstatus.errmsg);
                                    this.loading = false;

                                    // this.getFileList();
                                } else if (res.data.fmstatus.code == "3") {
                                    alert(res.data.fmstatus.errmsg);
                                    this.$router.push({
                                        name: "login",
                                    });
                                } else {
                                    this.loading = false;
                                    this.getFileList();
                                    this.$message({
                                        type: "success",
                                        message: `${this.$t("anti_gs1_tan.del1")}`,
                                    });
                                }
                            });

                    })
                    .catch(() => {
                                    this.loading = false;

                        this.$message({
                            type: "info",
                            message: `${this.$t("logs.kuaifa2")}`,
                        });
                    });
            }
        },
        // 打开关闭
        tanSend: function () {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid

            // console.log(arr, "全选后，获取的数组");
this.$search_hint_test();
            let col1 = {
                salt_minion_ip: this.salt_minion_ip,
                mta: this.mta,

                subject: this.subject,
                envfrom: this.envfrom,
                envrcpt: this.envrcpt,
                page:this.page,
                pagesize:this.pagesize,

            };
            
            this.$axios
                .get("/api/adm/cgi/mon.cgi", {
                    params: {
                        __mode: "show_cur_queue",
                        sid: sid,
                        col: col1,
                    },
                })
                .then((res) => {
                    console.log(res);
          
this.$close_search_hint_test();

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
 

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                    

                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                          this.tanchu = false;
            this.tanchu1 = false;
                         if (res.data.ret.HAS_MINION == 1) {
                           
                            this.salt_minion_ip = res.data.ret.col.salt_minion_ip;
                            this.minion_host = res.data.ret.q_minion_host;
                        }
                        if (res.data.ret.SYS_HAS_MULTI_MTA == 1) {
                           
                            this.q_mta = res.data.ret.q_mta;
                            this.mta = res.data.ret.col.mta;
                        }
                        this.fileList = res.data.ret.datalist
                        this.totalnums = res.data.ret.col.totalnums
                              this.size = res.data.ret.col.pagesize;
           
               this.size = res.data.ret.col.pagesize;
            this.page = res.data.ret.col.page;
            this.$nextTick(() => {
              this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
            });
            this.$refs.multipleTable.clearSelection()
                        // this.getFileList();
                        this.$message({
                            type: "success",
                            message: `${this.$t("logs.kuaifa4")}`,
                        });
                    }

                })

            this.subject = '',
                this.envfrom = '',
                this.envrcpt = ''
        },
        tan4: function () {
            this.tanchu = true;
            this.envfrom='';
            this.envrcpt='';
            this.subject='';
            //   this.tanchu1 = false;
        },
        tanOff: function () {
            this.tanchu = false;
            this.$message({
                type: "info",
                message: `${this.$t("logs.kuaifa5")}`,
            });
            //   this.tanchu1 = false;
        },
    },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";

/deep/ .has-gutter th:nth-child(1) {
    text-align: center;

}

// 表格居中位置
/deep/ .el-table__row td:nth-child(1) {
    text-align: center;

}

.table {
    margin-bottom: 0;
}

.fenye {
    border-left: 2px solid #D2D7E6;
    border-right: 2px solid #D2D7E6;
    border-bottom: 1px solid #D2D7E6;
    // border-bottom: 1px solid #D2D7E6;
    box-shadow: 0px 1px 0px 0px #D2D7E6;
    // margin-bottom: 5px;
    // border: 1px solid #ddd;
    height: 44px;
    // line-height:48px;

    line-height: 44px;
    display: flex;
    border-top: 0;
    align-items: center;

    margin: 0 14px;
    font-size: 14px;

    // background: #eee;
    /deep/ .el-select {
        padding: 0px 0px;
    }

    padding-left: 10px;

}

.main_select_margin {
    margin-left: 10px;
}

.main {

    margin-bottom: 10px;

    // input 框高度
    /deep/ .el-input__inner {
        height: 32px;
        padding: 0 6px;
    }

    span {
        margin-right: 8px;

        // width: 126px;
        // display: inline-block;
        color: #0E2C5E;

        font-family: PingFangSC-Medium, PingFang SC;
    }

}

.main_list {
    display: flex;
    align-items: center;

    margin-top: 10px;
}

.del_list {
    background: #FD8D43 !important;
}
/deep/.sent1 .cell{
    color: #f00 !important;
}
.el-table{
    height: calc(53vh);
}
</style>
